module.exports = __webpack_public_path__ + "img/13.14aabbc0.png";